module.exports = __webpack_public_path__ + "candidate_dashboard4.jpg?c1b1e4db8c1954e3410a01327d55ec34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/portfoliomanager/candidate_dashboard4.jpg
// module id = 18
// module chunks = 0